import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const TableSearchInput = ({ keyword, setKeyword }) => {
  return (
    <div className='search-input-container'>
      <input
        className={'search-input input'}
        onChange={(e) => setKeyword(e.target.value)}
        type="text"
        placeholder={'Keresés...'}
        value={keyword}
      />
      <FontAwesomeIcon className='search-icon' icon="magnifying-glass"></FontAwesomeIcon>
    </div>
  );
};

export default TableSearchInput;
